import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, TextField, Card, CardContent, Button, Box, MenuItem, FormControl, InputLabel, FormHelperText, makeStyles, Stack } from '@material-ui/core';
// shared - core components
import Toast from '../../../../shared/components/Toast/Toast'
import LoaderContent from '../../../../shared/components/Loader/LoaderContent.jsx'
//SDK
import { ThinkificService } from '@sdk-point/talisis';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';

const ThinkificServiceSDK = new ThinkificService(
    process.env.REACT_APP_ENV_V2,
    process.env.REACT_APP_X_API_KEY_V2
);

const breadcrumbItems = [
    { to: '/Home', label: 'Administrador', title: '' },
    { to: '/thinkific', label: 'Gestión de credenciales Thinkific', title: '' },
];


const BodyRequest = ({ readOnly = false, onClose, onSuccess, formData, onLoadingChange }) => {
    const classes = useStyles();
    const location = useLocation();
    const formFromState = location.state?.form;
    const [loading, setLoading] = React.useState(false);
    const [toastProps, setToastProps] = React.useState({ message: "", severity: "", open: false });
    const [errors, setErrors] = React.useState({});
    const [form, setForm] = React.useState({ id: null, ou: "", name: "", description: "" });
    const [companyOptions, setCompanyOptions] = React.useState([]);


    useEffect(() => {
        console.log("Datos recibidos desde formData:", formData);
        console.log("Datos recibidos desde location.state:", formFromState);
  
        const initialForm = formData || formFromState;
        if (initialForm) setForm(initialForm);
        getCompany();
    }, [formData, formFromState]);

    const handleChange = event => {
        const { name, value } = event.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleFinishedToast = () => setToastProps(prev => ({ ...prev, open: false }));

    const getCompany = async () => {
        const payloadgetCatalogs = { CatalogType: "company" };
        const companyData = await ThinkificServiceSDK.getCatalogs(payloadgetCatalogs);
        if (companyData.success) {
            const company = companyData.data.map(item => ({ id: item.id, label: item.name }));
            setCompanyOptions(company);
        }
    }

    const validateForm = () => {
        let newErrors = {};

        // Función helper para validar campos
        const validateField = (value) => {
            if (!value || value.trim() === "") {
                return `campo requerido`;
            }
            return null;
        };

        // Validar cada campo
        const ouError = validateField(form.ou);
        const nameError = validateField(form.name);
        const descriptionError = validateField(form.description);

        if (ouError) newErrors.ou = ouError;
        if (nameError) newErrors.name = nameError;
        if (descriptionError) newErrors.description = descriptionError;

        return newErrors;
    };

    const handleSubmit = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setToastProps({ severity: "error", open: true, message: "Completa todos los campos obligatorios" });
            return;
        }

        setErrors({});
        setLoading(true);
        if (onLoadingChange) {
            console.log('Activando spinner...');
            onLoadingChange(true);
        } else {
            console.log('onLoadingChange no está definido');
        }
        try {
           
            const cleanForm = {
                ...form,
                name: (form.name || "").toString().trim(),
                description: (form.description || "").toString().trim()
            };


            if (cleanForm.id) {
                // EDITAR
                const payloadUpdate = {
                    CatalogType: "bundle",
                    id: cleanForm.id,
                    uo: cleanForm.ou,
                    name: cleanForm.name,
                    description: cleanForm.description,
                };
                await ThinkificServiceSDK.updateCatalogs(payloadUpdate);
                setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

                setTimeout(() => {
                    if (onSuccess) onSuccess();
                }, 800);
            } else {
                // CREAR
                const payloadCreate = {
                    CatalogType: "bundle",
                    uo: cleanForm.ou,
                    name: cleanForm.name,
                    description: cleanForm.description,
                };
                await ThinkificServiceSDK.postCreateCatalogs(payloadCreate);
                setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

                setTimeout(() => {
                    if (onSuccess) onSuccess();
                }, 800);
            }
        } catch (error) {
            console.error("Error al guardar registro", error);
            setToastProps({ severity: "error", open: true, message: "Error al guardar: Nombre ya existe" });
        } finally {
            setLoading(false);
            if (onLoadingChange) {
                console.log('Desactivando spinner...');
                onLoadingChange(false);
            }
        }
    };

    const isEditMode = Boolean(form.id);

    return (
        <div>
            {/* <Breadcrumb items={breadcrumbItems} /> */}
            <Grid container spacing={3}>
                <Grid container item xs={12}>
                    <LoaderContent>
                        <Card>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid container item xs={12} spacing={2}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                select
                                                required
                                                label="Unidad Operativa"
                                                name="ou"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.ou || ""}
                                                onChange={handleChange}
                                                error={Boolean(errors.ou)}
                                                helperText={errors.ou}
                                                disabled={readOnly}
                                            >
                                                {companyOptions.map(option => (
                                                    <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                required
                                                label="Nombre"
                                                name="name"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.name}
                                                onChange={handleChange}
                                                error={Boolean(errors.name)}
                                                helperText={errors.name}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField
                                                required
                                                label="Descripción"
                                                name="description"
                                                margin="dense"
                                                variant="outlined"
                                                fullWidth
                                                value={form.description}
                                                onChange={handleChange}
                                                error={Boolean(errors.description)}
                                                helperText={errors.description}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </LoaderContent>
                </Grid>

                <Grid container item xs={12}>



                    <Box display="flex" justifyContent="flex-end" width="100%" backgroundColor={"white"} marginRight={"32px"}>


                        {!readOnly && (
                            <>
                                <Button
                                    className={classes.cancelButton}
                                    //color="default"
                                    variant="contained"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Regresar
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {isEditMode ? "Actualizar" : "Guardar"}
                                </Button>
                            </>
                        )}
                    </Box>
                </Grid>
                <Toast {...toastProps} onFinished={handleFinishedToast} />
            </Grid>
        </div>
    );
};

export default BodyRequest;
